import { createRoot } from 'react-dom/client';
import createModalMount from '@functions/createReactModalMount';
import { getCookie } from 'typescript-cookie';
import PersonaPersonalization from '@layouts/PersonaPersonalization/PersonaPersonalization';

window.addEventListener('DOMContentLoaded', () => {
    const helpButton = document.querySelector('.helpButtonEnabled') as HTMLElement;

    setTimeout(() => {
        const otherModals = Array.from(document.querySelectorAll('.ReactModalPortal')) as HTMLDivElement[];

        if (
            getCookie('persona') === undefined &&
            getCookie('terminal') === undefined &&
            otherModals.length === 0 &&
            (helpButton ? helpButton.style.display !== 'none' : true) &&
            window.location.pathname !== '/' &&
            window.location.pathname !== '/features/integrations/' &&
            window.location.pathname !== '/labor-management-system/' &&
            window.location.pathname !== '/inventory-management-system/' &&
            window.location.pathname !== '/tdintegrationd/'
        ) {
            const modal = createModalMount('persona-personalization-modal');
            const modalMount = createRoot(modal);
            modalMount.render(<PersonaPersonalization mount={modal} root={modalMount} />);
        }
    }, 5000);
});
